import { selectIntentCards } from '../../selectors/menu';
import { DEFAULT_INTENT_CARDS } from '../../constants/intents';
import {
  AgentInterceptionType,
  messagingActions,
  TextFrameTransmissionMessage,
} from '../../reducers/messagingSlice';
import { Intents } from '../../types/intent';
import useSendMessageHooks from '../useSendMessage/useSendMessage.hooks';
import useSlashCommandReminder from '../useSlashCommandReminder.hooks';
import useAgentInterception from '../agentInterception/useAgentInterception.hooks';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectFeatureFlagOCBReadback } from '../../redux/features/config/config.selector';
import { getMenuUnificationFeatureFlag } from '../../utils/session-storage';
import logger from '../../utils/logger';

const useReadback = () => {
  const dispatch = useAppDispatch();
  const { showSlashCommandReminder } = useSlashCommandReminder();
  const { sendReadBackMessage } = useSendMessageHooks();
  const { sendAgentInterception } = useAgentInterception();
  const isOCBReadbackEnabled = useAppSelector(selectFeatureFlagOCBReadback);
  const isBrandMenu = getMenuUnificationFeatureFlag();
  const intentCardsFromBM = useAppSelector(selectIntentCards);
  const INTENT_CARDS = intentCardsFromBM ?? DEFAULT_INTENT_CARDS;

  const sendOCBTTSMessage = (message: string) => {
    const payload: Partial<TextFrameTransmissionMessage> = {
      data: {
        payload: message,
        status: 'final',
        metadata: { intent: 'read-back' },
      },
    };
    dispatch(messagingActions.sendMessage(payload as any));
    sendAgentInterception({
      data: {
        type: AgentInterceptionType.TTS_SENT,
        description: message,
      },
    });
  };

  const handleReadBack = ({
    timePressed,
    forceRegularReadback = false,
  }: {
    timePressed: number;
    forceRegularReadback?: boolean;
  }) => {
    const readbackCard = INTENT_CARDS.find(
      (intent) => intent.intent === Intents.readback
    );
    const { intent, messages = [] } = readbackCard ?? {};

    if (!forceRegularReadback) {
      // HITL-1253: readback must not auto-populate or re-populate the
      // end-of-order upsell in the blue reminder.
      showSlashCommandReminder({ excludeUpsell: true });
    }

    if (isOCBReadbackEnabled && isBrandMenu && !forceRegularReadback) {
      sendOCBTTSMessage(messages?.[0] ?? '');
    } else {
      if (forceRegularReadback) {
        logger.log({
          message:
            'Readback: force regular readback - sending standard readback request (OCB TTS bypassed)',
          intent,
          timePressed,
        });
      }
      sendReadBackMessage(intent as string, timePressed);
    }
  };

  return {
    handleReadBack,
  };
};

export default useReadback;
